
import { defineComponent } from "vue";
import { loadPaginatedMatchinPayHistory } from "@/api/matchinpay";

export default defineComponent({
  name: "matchinpayhistory",
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  mounted() {
    this.loadPaginatedMatchinPayHistory();
  },
  methods: {
    async loadPaginatedMatchinPayHistory() {
      this.loading = true;
      const response = await loadPaginatedMatchinPayHistory(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
});
